import React, { useCallback } from 'react';
import { CALENDAR_VIEW } from '../../../util/varibles/constants';
import { getKeyWeek, jumpToTarget, SCROLL_TYPE } from '../../../util/varibles/global';
import Icon, { ICON_NAME } from '../../Icon';
import styles from './style.module.scss';

interface IProps {
    calenderId: string;
    calendarView?: CALENDAR_VIEW
    getHeightWeek(): number;
}

const ButtonJumpCalendar: React.FC<IProps> = ({
    calenderId,
    calendarView = CALENDAR_VIEW.VERTICAL,
    getHeightWeek,
}) => {
    // const handlePrev = useCallback(() => {
    //     const heightWeek = getHeightWeek();
    //     const parentEl = document.getElementById(calenderId);

    //     if (parentEl) {
    //         const { scrollTop } = parentEl;
    //         const position = Math.floor((scrollTop + 5) / heightWeek);

    //         parentEl.scrollTo({
    //             top: (position - 1) * heightWeek,
    //             behavior: 'smooth',
    //         });
    //     }
    // }, [calenderId, getHeightWeek]);

    // const handleNext = useCallback(() => {
    //     const heightWeek = getHeightWeek();
    //     const parentEl = document.getElementById(calenderId);

    //     if (parentEl) {
    //         const { scrollTop } = parentEl;
    //         const position = Math.floor(scrollTop / heightWeek);

    //         parentEl.scrollTo({
    //             top: (position + 1) * heightWeek,
    //             behavior: 'smooth',
    //         });
    //     }
    // }, [calenderId, getHeightWeek]);

    const handleToday = useCallback(() => {
        if (!calendarView || calendarView === CALENDAR_VIEW.VERTICAL) {
            jumpToTarget(calenderId);
        } else {
            const week = getKeyWeek(Date.now());
            jumpToTarget(calenderId, week, SCROLL_TYPE.HORIZONTAL);
        }
    }, [calenderId, calendarView]);

    return (
        <div className={styles.container}>
            {/* <div className={styles['bt-arrow']} onClick={handlePrev}>
                &#8593;
            </div> */}

            <div className="bt-ghost h-32" onClick={handleToday}>
                <Icon className={styles.icon} icon={ICON_NAME.CALENDAR} />
                <span>Today</span>
            </div>

            {/* <div className={styles['bt-arrow']} onClick={handleNext}>
                &#8595;
            </div> */}
        </div>
    );
};

export default ButtonJumpCalendar;